import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function GoBackButton() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // Fallback if no history available
      navigate('/');
    }
  };

  return (
    <button 
      className="go-back-button" 
      onClick={handleGoBack}
      title="عودة للصفحة السابقة" // Arabic for "Go Back"
      aria-label="Go back"
    >
       رجوع للصفحة السابقة 
    </button>
  );
}
